import { useGetVendorByDomain } from '@services/vendor/hooks/useGetVendorByDomain';
import Head from 'next/head';
import { ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cartSlice from '../../reducers/cart';
import vendorInformationSlice from '../../reducers/vendorInformation';
import { AppDispatch, RootState } from '../../stores';
import VendorUtil from '../../utils/vendorUtils';

interface Props {
  children: ReactNode;
}

const BaseLayout = ({ children }: Props) => {
  const cartVendorId = useSelector((state: RootState) => state.cart.vendorId);

  const { data: vendor, isSuccess } = useGetVendorByDomain(VendorUtil.getVendorDomain());

  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    if (vendor && isSuccess) {
      if (cartVendorId !== vendor?.data?.id) {
        dispatch(
          cartSlice.actions.init({
            vendorId: vendor?.data?.id || '',
            vendorName: vendor?.data?.name || '`',
            items: [],
            deliveryType: undefined,
            addressId: undefined,
            discountCode: undefined,
            tableNumber: undefined,
            tableName: undefined,
            numberOfPerson: 0,
            fetchAddressLoading: false,
          })
        );
      }
      dispatch(vendorInformationSlice.actions.init({ minimumBasket: vendor?.data?.minimumBasket || 0 }));
    }
  }, [cartVendorId, vendor, dispatch, isSuccess]);

  return (
    <div>
      <Head>
        <title>{vendor?.data?.name}</title>
      </Head>
      {children}
    </div>
  );
};

export default BaseLayout;
